import(/* webpackMode: "eager" */ "/vercel/path0/app/(pages)/author/[slug]/page.jsx")